import styled, { css } from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  ${({ theme }) => css`
    margin-left: auto;
    margin-right: auto;
    margin-top: 9rem;
    width: 40%;
    height: 410px;
    border: 0;
    background-color: ${theme.colors.gstWhite};
  `}
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    text-align: center;
    font-weight: 600;
    margin-bottom: 0;
    background-color: ${theme.colors.gstBlue};
    color: ${theme.colors.gstWhite};
    padding: 0.85rem;
    font-size: 0.9rem;
    font-family: "Raleway", sans-serif;
  `}
`;

export const CardBody = styled.div`
  /* ... */
`;

export const LoginTitle = styled.h3`
  font-family: "StagSansWeb-Medium";
  font-size: 46px;
  line-height: 55px;
  font-weight: 500;
  margin: 0 0 30px;
  font-weight: 500;
  @media only screen and (max-width: 767px) {
    width: 75%;
  }
`;

export const Form = styled.form`
  ${({ theme }) => css`
    padding: 0 5%;
    padding-top: 4%;
    background: ${theme.colors.gstWhite};
    height: 618px;
    @media only screen and (max-width: 770px) {
      height: 673px;
    }
    @media only screen and (min-width: 2560px) {
      height: 528px;
    }
    @media screen and (min-width: 1848px) and (max-width: 1920px) {
      height: 527px;
    }
  `}
`;

export const RegisterWrap = styled.div`
  ${({ theme }) => css`
    position: relative;
    top: 45px;
    left: 3px;
    bottom: 30px;
    a {
      font-size: 11px;
      color: #00bef4;
      text-transform: uppercase;
      cursor: pointer;
      font-weight: bold;
      margin-right: 30px;
      text-decoration: none;
      &:hover {
        color: ${theme.colors.hoverBlue};
        text-decoration: underline;
      }
    }
    @media only screen and (min-width: 1024px) {
      top: 75px;
    }
    @media only screen and (min-width: 1440px) {
      top: 122px;
    }
    @media screen and (min-width: 1848px) and (max-width: 1920px) {
      top: 12px;
    }
    @media only screen and (min-width: 2560px) {
      top: 10px;
    }
  `}
`;

export const ButtonContainer = styled.div`
  position: relative;
  left: 0;
  top: 5px;
  width: 50%;
  height: 55px;
  font-size: 16px;
  font-weight: 600;
  @media only screen and (min-width: 768px) {
    width: 100%;
    display: flex;
    top: 60px;
  }
  @media only screen and (min-width: 1024px) {
    width: 100%;
    display: flex;
    top: 78px;
  }
  @media only screen and (min-width: 1440px) {
    width: 100%;
    display: flex;
    top: 121px;
  }
  @media screen and (min-width: 1848px) and (max-width: 1920px) {
    width: 100%;
    display: flex;
    top: 23px;
  }
  @media only screen and (min-width: 2560px) {
    width: 100%;
    top: 15px;
  }
`;

export const EyeContainer = styled.div`
  position: relative;
  top: -55px;
  float: right;
  right: 19px;
  font-size: 20px;
  &:hover {
    color: #66d7d1;
  }
`;

export const Eye = styled.div``;

export const AccessInfo = styled.p`
  ${({ theme }) => css`
    font-size: 18px;
    margin-bottom: 35px;
    color: ${theme.colors.grey};
  `}
`;

export const ButtonClass = styled.div`
  & p {
    font-size: 0.75rem;
    width: 500%;
    padding-top: 15px;
    margin: 0 2% 0 0px;
    color: black;
    font-weight: 400;
    @media only screen and (max-width: 767px) {
      width: 100%;
      margin: 0 0 5% 0;
    }
  }
`;
